import React, { FC } from 'react';
import classNames from 'classnames';
import loadingSpinnerImageNew from '../images/loading-spinner-new.png';
import loadingSpinnerImageNew2x from '../images/loading-spinner-new@2x.png';
import loadingSpinnerImageNew3x from '../images/loading-spinner-new@3x.png';
import { stringifySrcset } from 'srcset';

type LoadingSpinnerProps = {
  className?: string;
};

const SRCSET = stringifySrcset([
  {
    url: loadingSpinnerImageNew,
    density: 1,
  },
  {
    url: loadingSpinnerImageNew2x,
    density: 2,
  },
  {
    url: loadingSpinnerImageNew3x,
    density: 3,
  },
]);

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ className }) => {
  return (
    <div className={classNames('flex items-center justify-center w-full', className)}>
      <img className='w-5 h-5 animate-spin' src={loadingSpinnerImageNew} srcSet={SRCSET} alt='loading' />
    </div>
  );
};
